import React,{useState, useEffect, useContext} from "react";
import { Col, Row, Container, Button, Table} from "react-bootstrap"
import { useNavigate } from "react-router-dom";


import {Editor,EditorState} from "draft-js"
import 'draft-js/dist/Draft.css';

import {stateFromHTML} from 'draft-js-import-html'
import { sanitizeHistoryHtml } from '../../Utils/historyHtml';


import { FiArrowLeft} from "react-icons/fi";


// import BandeiraMaranhao from "../BandeiraMaranhao";
import Logo4BPM from "../../components/Logo4BPM"
// import BrasaoMa from "../Brasao_Maranhao"
import LogoPMMA from "../../components/Logo_PMMA"

import MaterialDetalhe from "./Detalhe/MaterialDetalhe"
import PolicialDetalhe from "./Detalhe/PolicialDetalhe"
import EnvolvidosDetalhe from "./Detalhe/EnvolvidosDetalhe"
import ImprimirBoletimButton from "../../components/ImprimirBoletimButton"
import { hasPermission } from "../../Utils/permissions";
import { formatOperationalDateTime as formatarDataHora } from '../../Utils/operationalDateTime';
import './Detalhe/boletim-detalhe.css';

import { BoletimContext } from "../../context/BoletimContext";

const BoletimDetalhe = () => {
    const navigate = useNavigate();



    const {boletim} = useContext(BoletimContext)

    useEffect(() => {
        const state = boletim.historicohtml
          ? EditorState.createWithContent(stateFromHTML(sanitizeHistoryHtml(boletim.historicohtml)))
          : EditorState.createEmpty();
        setEditorState(state);
      }, [boletim?.historicohtml]);

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty())


 
   return ( <>
        <Container className="bo-review" style={{fontSize:"12px"}}>
            <br></br>
            <Row   className="text-center">
                <Col>
                    <LogoPMMA/>
                </Col>
                <Col style={{fontSize:"10px"}}>
                    {/* <BrasaoMa/> */}
                    <b><p>ESTADO DO MARANHÃO <br/>
                    SECRETARIA DE ESTADO DA SEGURANÇA PÚBLICA<br/>
                    POLÍCIA MILITAR DO MARANHÃO<br/>
                    COMANDO DO POLICIAMENTO DE ÁREA DO INTERIOR – CPAI-6<br/>
                    4º BATALHÃO DE POLÍCIA MILITAR
                    </p></b>
                </Col>
                <Col>
                    <Logo4BPM/>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">OCORRÊNCIA NUMERO:<b> {boletim.numero} {boletim.dataRegistro}</b></Col>
            </Row>
            <Row>
                <Col className="text-center">Registrado em :<b> {formatarDataHora(boletim.createdAt)}</b></Col>
            </Row>
            <hr/>
            <Row>
                <Col className="text-center"><h6>FATO COMUNICADO</h6></Col>
                
            </Row>
            <br/>
            <Row>
                <Col>
                    <b>Natureza da Ocorrência: </b> {boletim.natureza} 
                </Col>
                <Col>
                    <b>Data do Fato: </b>{boletim.data} 
                </Col>
                <Col>
                <b>Horário do Fato: </b>{boletim.horario}  
                </Col>
            </Row>
            <Row>
                <Col><b>Local:</b> {boletim.endereco} {boletim.numeroEndereco}  </Col>
                <Col><b>Bairro:</b> {boletim.bairro}</Col>
                <Col><b>Municipio:</b> {boletim.municipio}</Col>
            </Row>
            <Row>
                <Col><b>Ponto de Refêrencia :</b> {boletim.referencia}</Col>
                
                <Col><b>Coordenadas:</b> {boletim.latitude} {boletim.longitude}</Col>
                <Col></Col>
            </Row>
            <hr/>
            <Row>
            
                <Col className="text-center"><h6>ENVOLVIDO(S)</h6></Col>
                
            </Row>

            {boletim.envolvidos.map((envolvido, index) => (
                <EnvolvidosDetalhe key={envolvido._id || envolvido.id || index} envolvido={envolvido} />
            ))}
           
            
            <hr/>
        </Container>

        <Container className="bo-review" style={{fontSize:"12px"}}>
            {/**faz a quebra de pagina na impressao */}
            {/* <Row style={{pageBreakBefore:"always"}}>
            </Row>  */}

            <Row>
                <Col className="text-center"><h6>ARMAS E OBJETOS APREENDIDOS</h6></Col>
            </Row>
           
                {boletim.materiaisApreendidos.map((material, index) => (
                    <MaterialDetalhe key={material._id || material.id || index} material={material} />
                ))}
                   

            <hr/>

            <Row>
                <Col className="text-center"><h6>HISTÓRICO </h6></Col>
            </Row>

            <Row>
                <Editor editorState={editorState} onChange={setEditorState} readOnly={true}/>
            </Row>
            <hr/>

            <Row>
                <Col className="text-center"><h6>EFETIVO EMPREGADO</h6></Col>
            </Row>
            <Row>

            {boletim.efetivo.map(policial=><PolicialDetalhe key={policial.id} policial={policial}/>)}
                 
            </Row>
            <hr/>
            <Row>
                <Col className="text-center"><h6>UNIDADE DE ENTREGA</h6></Col>
            </Row>
            <Table borderless responsive>
                <tbody>
                <tr>
                    <td>Unidade ___________________________</td>
                    <td>Data  _______/________/_______</td>
                    <td>Hora       _________:_________</td>
                </tr>
                <tr>
                    <td>Matricula ___________________________</td>
                    <td>Nome ______________________________</td>
                    <td>Assinatura ___________________________</td>
                </tr>
                </tbody>
            </Table>

            <Row className="text-center">
                <Col>
                    <Button
                                  variant="outline-secondary"
                                  className="d-flex align-items-center gap-2"
                                  onClick={() => navigate(-1)}
                                >
                                  <FiArrowLeft />
                                  Voltar
                    </Button>
               </Col>
               <Col>
                   <Button
                       variant="outline-secondary"
                       className="d-print-none"
                       onClick={() => navigate("/dashboard")}
                   >
                       Voltar ao dashboard
                   </Button>
               </Col>
               <Col className="text-center">
                   {hasPermission("boletins.print") && (
                       <ImprimirBoletimButton
                           report={boletim}
                           className="d-print-none"
                       />
                   )}
                </Col>
                
            </Row>
            <br/>
            <hr/>
            <p className="d-print-none"><b>OBS:</b></p>

            <p className="d-print-none"><b>I - Imprimir</b> -  Para imprimir o boletim ou salvar PDF;</p>
            <p className="d-print-none"><b>II -  Voltar</b> -  Retorne a página anterior</p>
        </Container>
    </> );
}
 
export default BoletimDetalhe
